angular.module('picmonic-common')
    .directive("plsRtSourcing",['UserService', '$modal', function(UserService, $modal) {
        return {
            restrict: "A",
            link: function(scope, element, attr) {
              element.click(function(){
                  $modal.open({
                      windowClass: 'pls-educator-contact-form',
                      backdropClass: 'above-nav',
                      size: 'lg',
                      templateUrl: '/templates/modals/rt-sourcing-modal.html',
                      controller: ['$scope', function($scope){
                          $scope.UserService = UserService;
                      }]
                  });
              });
            }
        };
    }]);

